<template>
  <div style="padding: 2rem; background: #fff">
    <vxe-toolbar
      v-if="
        operateType === 'add' ||
        operateType === 'edit' ||
        operateType === 'renewal' ||
        operateType === 'changeInfo' ||
        operateType === 'changeSubject'
      "
    >
      <template v-slot:buttons>
        <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">新增</vxe-button>
        <vxe-button
          type="primary"
          class="vxe-btn-delete"
          @click="handleDelete('propertyTable')"
          :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      width="100%"
      align="left"
      show-header-overflow
      class="vxe-table-element"
      show-footer
      :footer-method="footerMethod"
      :auto-resize="true"
      border
      resizable
      show-overflow
      :data="propertyTableDate"
      :edit-config="editConfig"
      size="mini"
      ref="propertyTable"
      :max-height="$store.state.app.tableHeight"
      :edit-rules="propertyTableEditRules"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column
        field="rowIndex"
        title="行号"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot="{ row }">{{ row.lineNo || row.currentIndex }}</template>
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.rowIndex"
            @change="(val) => handleRowIndexChange(val, scope.row, scope)"
          >
            <el-option
              v-for="(item, index) in spaceTableData"
              :key="index"
              :label="item.rowIndex"
              :value="item.rowIndex"
            ></el-option>
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceAreaNo"
        title="片区"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAreaNo"
            clearable
            filterable
            @change="() => handleAreaChange(scope.row, scope, 'propertyTable')"
          >
            <el-option
              v-for="(item, index) in areaList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAreaNo, areaList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceAssetNo"
        title="资产名称"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceAssetNo"
            clearable
            filterable
            @change="() => handleAssetsChange(scope.row, scope, 'propertyTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.assetsList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceAssetNo, row.assetsList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceUnitNo"
        title="单元（楼栋）"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceUnitNo"
            clearable
            filterable
            @change="() => handleUnitChange(scope.row, scope, 'propertyTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.unitList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceUnitNo, row.unitList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceFloorNo"
        title="楼层"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceFloorNo"
            clearable
            filterable
            @change="() => handleFloorChange(scope.row, scope, 'propertyTable')"
          >
            <el-option
              v-for="(item, index) in scope.row.spaceFloorList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceFloorNo, row.spaceFloorList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceRoomNo"
        title="房号"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.spaceRoomNo"
            clearable
            filterable
            @change="() => handleRoomChange(scope.row)"
          >
            <el-option
              v-for="(item, index) in scope?.row?.roomList || []"
              :key="index"
              :label="item.name"
              :value="item.id"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.spaceRoomNo, row.roomList, 'id', 'name')
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="spaceArea"
        width="150"
        title="面积"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <InputNumber
            :max="'99999999999.99'"
            v-model="scope.row.spaceArea"
            :precision="2"
            @input="() => changeSpaceAreHandler(scope.row)"
          ></InputNumber>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="expenseType"
        title="费用类型"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.expenseType" clearable filterable>
            <el-option
              v-for="(item, index) in propertyExpenseList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.expenseType, propertyExpenseList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="chargeMethod"
        title="计费方式"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.chargeMethod"
            clearable
            filterable
            @change="() => handleChargeMethods(scope.row, scope, 'propertyTable', 'chargeMethod')"
          >
            <el-option
              v-for="(item, index) in spaceChargeMethodList"
              :key="index"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          transferSelect(row.chargeMethod, spaceChargeMethodList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column field="measurementUnit" title="计量单位" width="120">
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.measurementUnit" clearable filterable>
            <el-option
              v-for="(item, index) in productUnitList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ row.chargeMethod ? '月' : '' }}</template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="chargeUnitPrice"
        title="计费单价"
        width="120"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <InputNumber
            :max="'9999999.99'"
            v-model="scope.row.chargeUnitPrice"
            :precision="3"
            @input="() => handleChargeMethods(scope.row, scope, 'propertyTable', 'chargeUnitPrice')"
          ></InputNumber>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column
        field="chargePrice"
        title="计费金额（元/月）"
        width="200"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <InputNumber
            :max="'9999999.99'"
            v-model="scope.row.chargePrice"
            :precision="2"
          ></InputNumber>
        </template>
      </vxe-table-column> -->
      <vxe-table-column field="priceSetting" title="价格设置" width="120">
        <template #default="scope">
          <el-button type="text" @click="() => priceSettingRowHandler(scope.row)">{{
            operateType === 'detail' || operateType === 'audit'
              ? '查看'
              : scope.row.leaseContractPropertyDetails?.length > 0
              ? '修改'
              : '新增'
          }}</el-button>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="chargeCycle"
        title="计费周期"
        width="120"
        :edit-render="{
          name: 'default',
        }"
      >
        <template v-slot:edit="scope">
          <el-select v-model="scope.row.chargeCycle" clearable filterable>
            <el-option
              v-for="(item, index) in chargeCycleList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ transferSelect(row.chargeCycle, chargeCycleList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        v-if="['detail', 'audit'].includes(operateType)"
        field="chargeAmount"
        title="金额"
        width="120"
      >
      </vxe-table-column>
      <!-- <vxe-table-column
        field="annualGrowthRate"
        title="年增长比例"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="'999.99'"
            v-model="scope.row.annualGrowthRate"
            precision="2"
          ></input-number>
        </template>
      </vxe-table-column> -->
      <vxe-table-column
        field="firstSettlementDate"
        title="首次结算日期"
        width="150"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-date-picker
            v-model="scope.row.firstSettlementDate"
            value-format="yyyy-MM-dd"
            type="date"
            style="width: 120px"
            placeholder=""
            :picker-options="pickerSettleOptions"
            :disabled="operateType === 'changeInfo' && scope.rowIndex !== -1 ? true : false"
          >
          </el-date-picker>
        </template>
      </vxe-table-column>
      <vxe-table-column field="remark" title="备注" width="120" :edit-render="{ type: 'default' }">
        <template v-slot:edit="scope">
          <el-input v-model="scope.row.remark" maxlength="20" />
        </template>
      </vxe-table-column>
      <vxe-table-column field="operation" title="免租期设置" width="120">
        <template #default="scope">
          <el-button type="text" @click="() => settleRentFreeRowHandler(scope.row)">{{
            operateType === 'detail' || operateType === 'audit' ? '查看' : '设置'
          }}</el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <SettleRentFreeDialog
      :isDisabled="operateType === 'detail' || operateType === 'audit'"
      ref="settleRentFreeDialogRef"
      @submit="settleRendFreeSubmitHandler"
    />
    <!-- 价格设置 -->
    <PriceSetDialog
      ref="priceSetDialogRef"
      :isDisabled="operateType === 'detail' || operateType === 'audit'"
      :startDate="startDate"
      :endDate="endDate"
      :isShowPriceList="isShowPriceList"
      @submit="priceChangeConfirm"
    ></PriceSetDialog>
  </div>
</template>

<script>
  import leaseContractMixin from '@/pages/property/leaseContract/mixins/leaseContract';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import {
    leaseSpaceChargeMethodList,
    productUnitList,
    chargeCycleList,
    propertySpaceChargeMethodList,
  } from '../data';
  import SettleRentFreeDialog from './SettleRentFreeDialog';
  import PriceSetDialog from './PriceSetDialog';
  export default {
    name: 'propertyExpense',
    mixins: [leaseContractMixin],
    props: [
      'leaseDateFrom',
      'leaseDateUntil',
      'detailPropertyExpensesTableData',
      'spaceTableData',
      'contractCategory',
    ],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      propertyTableEditRules() {
        return {
          spaceAreaNo: [
            {
              required: this.isPropertyContract ? true : false,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          spaceAssetNo: [
            {
              required: this.isPropertyContract ? true : false,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          // spaceUnitNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceFloorNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          // spaceRoomNo: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
          chargeMethod: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          expenseType: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          chargePrice: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur',
            },
          ],
          chargeUnitPrice: [
            {
              required: true,
              message: '请填写',
              trigger: 'blur',
            },
          ],
          measurementUnit: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          chargeCycle: [
            {
              required: true,
              message: '请选择',
              trigger: 'blur',
            },
          ],
          // annualGrowthRate: [
          //   {
          //     required: true,
          //     message: '请填写',
          //     trigger: 'blur',
          //   },
          // ],
          // firstSettlementDate: [
          //   {
          //     required: true,
          //     message: '请选择',
          //     trigger: 'blur',
          //   },
          // ],
        };
      },
      operateType() {
        return this.$route.query.type;
      },
      pickerSettleOptions() {
        return {
          disabledDate: (time) => {
            return time < new Date(this.startDate) - 8.64e7 || time > new Date(this.endDate);
          },
        };
      },
    },
    watch: {
      leaseDateFrom(newVal) {
        this.startDate = newVal;
      },
      leaseDateUntil(newVal) {
        this.endDate = newVal;
      },
      contractCategory(val) {
        console.log('====监听', val);
        if (val == '02') {
          console.log('计费方式', this.propertySpaceChargeMethodList);
          this.isPropertyContract = false;
          this.spaceChargeMethodList = this.propertySpaceChargeMethodList;
        }
        if (val == '01') {
          this.isPropertyContract = true;
          this.spaceChargeMethodList = this.leaseSpaceChargeMethodList;
        }
        console.log('isPropertyContract', this.isPropertyContract);
      },
      detailPropertyExpensesTableData(newVal) {
        if (newVal) {
          console.log('表格数据', newVal);
          this.dealDetailData(newVal);
        }
      },
    },
    data() {
      return {
        propertyTableDate: [],
        editConfig: {},
        propertyExpenseList: [],
        startDate: '',
        endDate: '',
        spaceChargeMethodList: leaseSpaceChargeMethodList,
        productUnitList,
        chargeCycleList,
        propertySpaceChargeMethodList,
        editRowItem: null,
        isPropertyContract: true,
        isShowPriceList: false,
      };
    },
    created() {
      this.getArea();
      this.getPropertyExpenseList();
    },
    mounted() {
      this.editConfig =
        this.operateType === 'add' ||
        this.operateType === 'edit' ||
        this.operateType === 'renewal' ||
        this.operateType === 'changeInfo' ||
        this.operateType === 'changeSubject'
          ? { trigger: 'dblclick', mode: 'row' }
          : {};
    },
    methods: {
      priceChangeConfirm(res) {
        console.log(res, '提交后的数据，需要替换当前编辑的行');
        const tableDataList = this.$refs.propertyTable.getTableData().fullData || [];
        const currentIndex = tableDataList.findIndex((item) => item._XID == res._XID);
        tableDataList.splice(currentIndex, 1, res);
        this.isShowPriceList = true;
        this.propertyTableDate = tableDataList;
      },
      priceSettingRowHandler(rowData) {
        if (!rowData.chargeMethod || rowData.chargeMethod?.length == 0) {
          this.$message.error('请先选择计费方式');
          return;
        }
        if (!rowData.spaceArea || rowData.spaceArea?.length == 0) {
          this.$message.error('请先输入面积');
          return;
        }
        this.$refs.priceSetDialogRef.openModal(rowData, 'property');
      },
      handleRowIndexChange(val, row, scope) {
        console.log(val, row, scope, '---->>');
        const currentItem = this.spaceTableData.find((item) => item.rowIndex == val);
        console.log(JSON.stringify(currentItem), '选中的');
        row['spaceId'] = currentItem['spaceId'];
        row['spaceAreaNo'] = currentItem['spaceAreaNo'];
        row['spaceAssetNo'] = currentItem['spaceAssetNo'];
        row['assetsList'] = currentItem['assetsList'];
        row['spaceUnitNo'] = currentItem['spaceUnitNo'];
        row['unitList'] = currentItem['unitList'];
        row['spaceFloorNo'] = currentItem['spaceFloorNo'];
        row['spaceFloorList'] = currentItem['spaceFloorList'];
        row['spaceRoomNo'] = currentItem['spaceRoomNo'];
        row['roomList'] = currentItem['roomList'];
        row['spaceArea'] = currentItem['spaceArea'];
        row['currentIndex'] = val;
      },
      settleRendFreeSubmitHandler(rowData) {
        console.log(rowData, '提交后的数据，需要替换当前编辑的行');
        const tableDataList = this.$refs.propertyTable.getTableData().fullData || [];
        const currentIndex = tableDataList.findIndex((item) => item._XID == rowData._XID);
        tableDataList.splice(currentIndex, 1, rowData);
        this.propertyTableDate = tableDataList;
      },
      // 免租设置
      settleRentFreeRowHandler(rowData) {
        console.log(this.leaseDateFrom, '表单数据', this.leaseDateUntil);
        console.log(rowData);
        this.editRowItem = rowData;
        if (!this.leaseDateFrom || !this.leaseDateUntil) {
          this.$message.warning('请补充租赁时间范围');
          return;
        }
        this.$refs.settleRentFreeDialogRef.openModel(
          rowData,
          this.leaseDateFrom,
          this.leaseDateUntil
        );
      },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['chargePrice'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.chargePrice, 0).toFixed(2);
            }
            if (['chargeAmount'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.chargeAmount, 0).toFixed(2);
            }
            // 价格合计
            if (['priceSetting'].includes(column.property)) {
              let sum = '';
              let nowTime = moment(new Date()).format('YYYY-MM-DD');
              data.forEach((item) => {
                item.leaseContractPropertyDetails.forEach((info, index) => {
                  // 价格合计取当前时间所在区间的价格进行计算，如果超出期限，按照最后的区间价格进行合计
                  // 未进入计费区间取第一条
                  if (
                    (nowTime >= info.leaseDateFrom && nowTime <= info.leaseDateUntil) ||
                    (index == item.leaseContractPropertyDetails.length - 1 &&
                      nowTime > info.leaseDateUntil) ||
                    (nowTime < info.leaseDateFrom && index == 0)
                  ) {
                    sum = (sum - 0 + (info.chargePrice - 0)).toFixed(3);
                  }
                });
              });
              return sum;
            }
            return null;
          }),
        ];
      },
      openInfoHandler() {
        this.$refs.firstSettlementDialogRef.openModal();
      },
      // getExpenseType() {
      //   this.$axios
      //     .post(API.DATA_DICT, {
      //       dictType: 'leaseContract-expenseType',
      //       tenantCode: this.userInfo.tenantCode,
      //     })
      //     .then((res) => {
      //       console.log(res, 'propertyExpenseList');
      //       if (res.data.code === 0) {
      //         this.propertyExpenseList = res.data.data || [];
      //         let arr = [];
      //         if (this.propertyTableDate.length > 0) {
      //           this.propertyTableDate.forEach((property) => {
      //             arr.push(property.expenseType);
      //           });
      //         }
      //         this.propertyExpenseList.forEach((item) => {
      //           this.currExpenseList.push({
      //             label: item.label,
      //             value: item.value,
      //             disabled: arr.includes(item.value) ? true : false,
      //           });
      //         });
      //       }
      //     });
      // },
      async dealDetailData(list) {
        for (let item of list) {
          if (item.spaceAreaNo) {
            await this.getAssetsList(item);
          }
          if (item.spaceAssetNo) {
            await this.getUnitList(item);
          }
          if (item.spaceUnitNo) {
            await this.getSpaceFloorList(item);
          }
          if (item.spaceFloorNo) {
            await this.getRoomList(item);
          }
        }
        this.propertyTableDate = list.map((item, index) => {
          return {
            ...item,
            rowIndex: index + 1,
          };
        });
        // if (this.operateType !== 'add') {
        //   this.dealTypeData();
        // }
      },
      // dealTypeData() {
      //   let arr = [];
      //   this.currExpenseList = [];
      //   this.propertyTableDate.forEach((property) => {
      //     arr.push(property.expenseType);
      //   });
      //   this.propertyExpenseList.forEach((item) => {
      //     if (item.value) {
      //       this.currExpenseList.push({
      //         label: item.label,
      //         value: item.value,
      //         disabled: arr.includes(item.value) ? true : false,
      //       });
      //     }
      //   });
      // },
      // handleExpenseTypeChange(val) {
      //   console.log(val, '111');
      //   const arr = [];
      //   let expensesTypeData = this.$refs.propertyTable.getTableData().fullData;
      //   expensesTypeData.forEach((expenses) => {
      //     arr.push(expenses.expenseType);
      //   });
      //   this.currExpenseList.forEach((item) => {
      //     if (item.value === val || arr.includes(item.value)) {
      //       item.disabled = true;
      //     } else {
      //       item.disabled = false;
      //     }
      //   });
      // },
      insertEvent() {
        this.$refs['propertyTable'].validate((valid) => {
          if (valid) {
            let record = {
              spaceAreaNo: '',
              spaceAssetNo: '',
              spaceUnitNo: '',
              spaceFloorNo: '',
              spaceRoomNo: '',
              chargeMethod: '',
              expenseType: '',
              chargePrice: '',
              chargeUnitPrice: '',
              measurementUnit: '',
              chargeCycle: '',
              // annualGrowthRate: '',
              firstSettlementDate: '',
              remark: '',
              leaseContractPropertyDetails: [],
            };
            this.$refs.propertyTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.propertyTable.setActiveRow(row));
          }
        });
      },
      // handleDelete(tableType) {
      //   const selectedList = this.$refs[tableType].getSelectRecords(); // 或许选中数据
      //   if (selectedList.length < 1) {
      //     this.$message({
      //       showClose: true,
      //       message: this.$t('goods.message.noChooseDel'),
      //       type: 'error',
      //     });
      //     return;
      //   }
      //   this.$confirm('是否确认删除')
      //     .then(() => {
      //       this.$refs[tableType].removeSelecteds();
      //       const deleteArr = [];
      //       selectedList.forEach((selected) => {
      //         deleteArr.push(selected.expenseType);
      //       });
      //       console.log(deleteArr, 'deleteArr');
      //       this.currExpenseList.forEach((curr) => {
      //         if (deleteArr.includes(curr.value)) {
      //           curr.disabled = false;
      //         }
      //       });
      //       this.$message({
      //         showClose: true,
      //         type: 'success',
      //         message: this.$t('goods.message.delSuccess'),
      //       });
      //     })
      //     .catch(() => {
      //       this.$message({
      //         showClose: true,
      //         type: 'info',
      //         message: this.$t('goods.message.unDel'),
      //       });
      //     });
      // },
    },
    components: {
      SettleRentFreeDialog,
      PriceSetDialog,
    },
  };
</script>

<style lang="scss" scoped>
  .title {
    font-size: 20px;
    font-weight: 600;
  }
</style>
